/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
export class DriverDrivingLevel{
  driverId:number;
  attachment:string;
  campusDrivingPermitNumber:string;
  driverDrivingLevelId:number;
  drivingLevelDesc:string;
  drivingLevelId:number;
  drivingLevelName:string;
  expirationDate:string;
  provingGroundLicenseNumber:string;
  siteId:number;
  siteName:string;
  trainingDate:string;
}
